import {
  User,
  Conversation,
  Message,
  Participant,
} from '@twilio/conversations';
import {
  ChatUser,
  ChatUserAttributes,
  ChatConversation,
  ChatConversationAttributes,
  ChatMessage,
  ChatMessageAttributes,
  ChatParticipant,
} from '../types';

export const userToChatUser = (user: User): ChatUser => {
  const rowAttributes = user.attributes;
  const attributes: ChatUserAttributes =
    rowAttributes &&
    typeof rowAttributes === 'object' &&
    !Array.isArray(rowAttributes) &&
    ['vp', 'internal'].includes(rowAttributes.type as string)
      ? (rowAttributes as ChatUserAttributes)
      : { type: 'unknown' };

  return {
    instance: user,
    identity: user.identity,
    friendlyName: user.friendlyName || '',
    attributes,
  };
};

export const conversationToChatConversation = (
  conversation: Conversation,
): ChatConversation => {
  const rowAttributes = conversation.attributes;
  const attributes: ChatConversationAttributes =
    rowAttributes &&
    typeof rowAttributes === 'object' &&
    !Array.isArray(rowAttributes) &&
    ['counter', 'po', 'reorder'].includes(rowAttributes.type as string)
      ? (rowAttributes as ChatConversationAttributes)
      : { type: 'unknown' };

  return {
    instance: conversation,
    sid: conversation.sid,
    uniqueName: conversation.uniqueName || '',
    friendlyName: conversation.friendlyName || '',
    attributes,
  };
};

export const messageToChatMessage = async (
  message: Message,
): Promise<ChatMessage> => {
  const rowAttributes = message.attributes;
  const attributes: ChatMessageAttributes =
    rowAttributes &&
    typeof rowAttributes === 'object' &&
    !Array.isArray(rowAttributes) &&
    ['text', 'tiptap', 'last-message'].includes(rowAttributes.type as string)
      ? (rowAttributes as ChatMessageAttributes)
      : { type: 'unknown' };

  const files = await Promise.all(
    message.attachedMedia?.map(async (media) => ({
      name: media.filename || 'unknown',
      type: media.contentType,
      url: (await media.getContentTemporaryUrl()) || '',
    })) || [],
  );

  return {
    instance: message,
    sid: message.sid,
    body: message.body || '',
    files,
    attributes,
  };
};

export const participantToChatParticipant = (
  participant: Participant,
): ChatParticipant => ({
  instance: participant,
  sid: participant.sid,
  identity: participant.identity || '',
  attributes: { type: 'unknown' },
});
